/* Kelany — dedicated Bestseller page grid. Mirrors the React <BestsellerPage/>
 * grid 1:1. Reads assets/catalog.json, keeps only products where
 * bestseller === true, and renders the same card markup as the collection grid
 * (elegant bottle render by gender, real /products/<handle> link, native
 * Shopify add-to-cart form intercepted by theme.js). Self-contained so it does
 * not depend on the store having a real `bestseller` collection. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bestseller-root]');
  if (!root) return;
  var gridHerren = root.querySelector('[data-bestseller-grid="herren"]');
  var gridDamen = root.querySelector('[data-bestseller-grid="damen"]');
  if (!gridHerren && !gridDamen) return;

  var cfg = {
    catalogUrl: root.getAttribute('data-catalog-url'),
    productsUrl: root.getAttribute('data-products-url'),
    imgHerren: root.getAttribute('data-img-herren'),
    imgDamen: root.getAttribute('data-img-damen'),
    imgDefault: root.getAttribute('data-img-default'),
    cartAdd: root.getAttribute('data-cart-add') || '/cart/add',
  };

  // ── helpers (identical to collection.js) ────────────────────────────────────
  var eur = function (n) { return '€' + Number(n).toFixed(2).replace('.', ','); };
  var esc = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };
  // 3-image structure (mirrors product-card.liquid): image 1 = blank bottle by
  // gender (Damen → weiss-pink, Herren/Unisex → schwarz), image 2 = fragrance-
  // family lifestyle (by gender + family) revealed on hover.
  var FAM_SLUG = {
    'Süß · Gourmand': 'suess-gourmand',
    'Orientalisch · Amber': 'orientalisch-amber',
    'Holzig · Würzig': 'holzig-wuerzig',
    'Blumig · Floral': 'blumig-floral',
    'Fruchtig': 'fruchtig',
    'Frisch · Zitrisch': 'frisch-zitrisch'
  };
  var KELANY_CDN = 'https://cdn.shopify.com/s/files/1/1006/6434/4901/files/';
  var blankFor = function (gender) {
    return String(gender || '').toUpperCase() === 'DAMEN' ? cfg.imgDamen : cfg.imgHerren;
  };
  var familyImgFor = function (p) {
    var slug = FAM_SLUG[p.family] || 'orientalisch-amber';
    var bt = String(p.gender || '').toUpperCase() === 'DAMEN' ? 'weisspink' : 'schwarz';
    return KELANY_CDN + 'kelany-fam-' + slug + '-' + bt + '.png?width=900';
  };
  var badgeOf = function (p) { return p.bestseller ? 'BESTSELLER' : p.isNew ? 'NEU' : ''; };
  var defaultVariant = function (p) { return (p.variants && p.variants[0]) || null; };
  var ICON_EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>';
  var starsHtml = function () {
    var s = '<div class="flex items-center gap-0.5 text-gold">';
    for (var i = 0; i < 5; i++) {
      s += '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"/></svg>';
    }
    return s + '</div>';
  };

  // ── card markup (identical to collection.js cardHtml) ───────────────────────
  function cardHtml(p) {
    var badge = badgeOf(p);
    var href = cfg.productsUrl + encodeURIComponent(p.handle);
    var blankImg = blankFor(p.gender);
    var famImg = familyImgFor(p);
    var v = defaultVariant(p);
    var badgeHtml = badge
      ? '<span class="card-badge pointer-events-none absolute right-4 top-4 z-20 bg-noir/85 px-3 py-1.5 text-[9px] font-medium uppercase tracking-label text-gold backdrop-blur-sm">' + esc(badge) + '</span>'
      : '';
    var formHtml = v
      ? '<form action="' + esc(cfg.cartAdd) + '" data-product-form method="post" class="relative z-20 mt-2 max-h-0 overflow-hidden opacity-0 transition-all duration-300 ease-premium group-hover:max-h-12 group-hover:opacity-100">' +
          '<input type="hidden" name="id" value="' + esc(v.id) + '">' +
          '<button type="submit" class="link-ghost text-[10px] uppercase tracking-label">→ In den Warenkorb</button>' +
        '</form>'
      : '';

    return '<article class="group relative flex shrink-0 flex-col bg-obsidian/40 text-left transition-transform duration-500 ease-premium hover:-translate-y-1 w-full">' +
      '<a href="' + esc(href) + '" class="absolute inset-0 z-10" aria-label="' + esc(p.sku) + '"></a>' +
      '<div class="relative aspect-square overflow-hidden bg-cream">' +
        badgeHtml +
        '<span class="card-gender pointer-events-none absolute left-4 top-4 z-20 text-[9px] font-medium uppercase tracking-label text-noir/65">' + esc(p.gender) + '</span>' +
        '<img src="' + esc(blankImg) + '" alt="' + esc(p.sku) + '" loading="lazy" class="absolute inset-0 h-full w-full object-cover transition-opacity duration-[600ms] ease-premium group-hover:opacity-0">' +
        '<img src="' + esc(famImg) + '" alt="' + esc(p.sku) + ' — ' + esc(p.family) + '" loading="lazy" class="absolute inset-0 h-full w-full object-cover opacity-0 transition-all duration-[1100ms] ease-premium group-hover:scale-[1.04] group-hover:opacity-100">' +
      '</div>' +
      '<div class="flex flex-1 flex-col gap-3 px-1 pt-6 pb-5">' +
        '<h3 class="flex items-baseline justify-between gap-3 font-display text-2xl font-light not-italic text-ivory">' +
          '<span class="tracking-wide">' + esc(p.sku) + '</span>' +
          '<span class="font-sans text-[10px] uppercase tracking-label text-sand">' + esc(p.gender) + '</span>' +
        '</h3>' +
        '<p class="text-[11px] font-light leading-[1.8] text-sand">' + esc(p.family) + '</p>' +
        '<div class="flex items-center justify-between pt-1">' +
          '<span class="font-display text-2xl text-gold">ab ' + eur(p.price) + '</span>' +
          starsHtml() +
        '</div>' +
        formHtml +
      '</div>' +
    '</article>';
  }

  var isDamen = function (p) { return String(p.gender || '').toUpperCase() === 'DAMEN'; };

  // ── load + render ───────────────────────────────────────────────────────────
  fetch(cfg.catalogUrl)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data && data.products) || [];
      var best = products.filter(function (p) { return p.bestseller; });
      var herren = best.filter(function (p) { return !isDamen(p); });
      var damen = best.filter(isDamen);
      var empty = '<p class="col-span-full text-sm font-light text-sand">Aktuell keine Bestseller markiert.</p>';
      if (gridHerren) gridHerren.innerHTML = herren.length ? herren.map(cardHtml).join('') : empty;
      if (gridDamen) gridDamen.innerHTML = damen.length ? damen.map(cardHtml).join('') : empty;
    })
    .catch(function () {
      var msg = '<p class="col-span-full text-sm font-light text-sand">Bestseller konnten nicht geladen werden.</p>';
      if (gridHerren) gridHerren.innerHTML = msg;
      if (gridDamen) gridDamen.innerHTML = msg;
    });
})();
